module.exports = __webpack_public_path__ + "img/qrcode2.ec89f202.png";